import { View } from 'backbone.marionette';
import Syphon from 'backbone.syphon';
import _ from 'lodash';

import showSuccessMessage from '@/util/ShowSuccessMessage';
import showErrorMessage from '@/util/showErrorMessage';
import { formatDisplayDate, formatServerDateTime, parseDisplayDate } from '@/util/MomentUtils';
import { validateForm } from '@/util/ParsleyUtils';

import SaveCustomerOrderGeneral from '../../../services/SaveCustomerOrderGeneral';

import tmplMaintenanceGeneralView from './MaintenanceGeneralView.hbs';

const MaintenanceGeneralView = View.extend({
  template: tmplMaintenanceGeneralView,

  className: 'maintenance-general-view',

  ui: {
    dateEquipmentReq: 'input[name="dateEquipmentReq"]',
    commandPOC: '#commandPOC',
    generalForm: '.general-form',
    firstName: '#firstName',
    lastName: '#lastName',
    email: '#email',
    telephone: '#telephone'
  },

  events: {
    'change @ui.commandPOC': 'onCommandPOCChange'
  },

  onRender() {
    const order = this.model.get('order');

    this.ui.dateEquipmentReq.datepicker({ format: 'mm/dd/yyyy' });
    if (order.dateEquipmentReq) {
      this.ui.dateEquipmentReq.datepicker('setDate', formatDisplayDate(order.dateEquipmentReq));
    }

    order.hasReq = order.specialBaseBuildingAccessReq;
    order.accessNotes = order.specialBaseBuildingAccessNotes;
  },

  onCommandPOCChange() {
    const commandPOCs = this.model.get('orderDetails').commandPOCs;
    const commandId = this.ui.commandPOC.val();

    if (commandId) {
      const command = _.find(commandPOCs, { id: commandId });
      this.$('#firstName').val(`${command.firstName}`);
      this.$('#lastName').val(`${command.lastName}`);
      this.$('#email').val(command.email);
      this.$('#telephone').val(command.telephone);
    } else {
      this.$('#firstName').val('');
      this.$('#lastName').val('');
      this.$('#email').val('');
      this.$('#telephone').val('');
    }
    validateForm(this.ui.generalForm, 'commandPOCInfo');
  },

  async validate() {
    const isReadOnly = this.model.get('isReadOnly');

    try {
      if (isReadOnly) this.ui.generalForm.find(':input').prop('disabled', false);
      await validateForm(this.ui.generalForm);
      this.trigger('no:errors');
      return true;
    } catch {
      if (isReadOnly) {
        this.ui.generalForm.find(':input').prop('disabled', true);
      }
      this.trigger('has:errors');
      return false;
    }
  },

  async onAttach() {
    if (this.model.get('orderDetails').showValidation) {
      await this.validate();
    }
  },

  async onSave() {
    const generalFormData = Syphon.serialize(this);

    if (generalFormData.dateEquipmentReq) {
      const dateEquipmentReq = formatServerDateTime(parseDisplayDate(generalFormData.dateEquipmentReq));
      generalFormData.dateEquipmentReq = dateEquipmentReq;
    }

    const formData = {
      generalFormData,
      orderId: this.model.get('orderDetails').orderId,
      orderTypeId: this.model.get('orderDetails').orderTypeId
    };

    try {
      await SaveCustomerOrderGeneral(formData);

      Object.assign(this.model.get('order'), {
        ...generalFormData,
        hasReq: generalFormData.specialBaseBuildingAccessReq,
        accessNotes: generalFormData.specialBaseBuildingAccessNotes
      });

      this.showSaveSuccess();
    } catch (err) {
      this.showSaveError();
      throw new Error(err);
    }
  },

  showSaveError() {
    showErrorMessage({
      errorCode: 'saveError',
      errorTitle: 'Save Error',
      errorMessage:
        'An error occurred while saving general information for this order. Try again or contact an administrator if your issue persists.'
    });
  },

  showSaveSuccess() {
    showSuccessMessage({
      code: 'saveSuccess',
      title: 'Save Success',
      message: 'This order has been saved successfully.',
      hideAfter: 5
    });
  }
});

export default MaintenanceGeneralView;
